// PREZENCE — Sidebar (UPDATED: added Leaves + Activity for admin)
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = {
  admin: [
    { label:'Dashboard',  path:'/admin',              icon:'⬡' },
    { label:'Employees',  path:'/admin/employees',    icon:'◈' },
    { label:'Departments',path:'/admin/departments',  icon:'▦' },
    { label:'Activity',   path:'/admin/activity',     icon:'◉' },
    { label:'Leaves',     path:'/admin/leaves',       icon:'◧' },
    { label:'Screenshots',path:'/admin/screenshots',  icon:'⬜' },
    { label:'Reports',    path:'/admin/reports',      icon:'▤'  },
    { label:'Analytics',  path:'/admin/analytics',    icon:'◭'  },
    { label:'Audit Log',  path:'/admin/audit',        icon:'⛨'  },
    { label:'Consent',    path:'/admin/consent',      icon:'✍' },
    { label:'Profile',    path:'/admin/profile',      icon:'⊙' },
  ],
  superadmin: [
    { label:'Dashboard',  path:'/admin',              icon:'⬡' },
    { label:'Employees',  path:'/admin/employees',    icon:'◈' },
    { label:'Departments',path:'/admin/departments',  icon:'▦' },
    { label:'Activity',   path:'/admin/activity',     icon:'◉' },
    { label:'Leaves',     path:'/admin/leaves',       icon:'◧' },
    { label:'Screenshots',path:'/admin/screenshots',  icon:'⬜' },
    { label:'Reports',    path:'/admin/reports',      icon:'▤'  },
    { label:'Analytics',  path:'/admin/analytics',    icon:'◭'  },
    { label:'Audit Log',  path:'/admin/audit',        icon:'⛨'  },
    { label:'Consent',    path:'/admin/consent',      icon:'✍' },
    { label:'Profile',    path:'/admin/profile',      icon:'⊙' },
  ],
  employee: [
    { label:'My Dashboard',path:'/employee',             icon:'⬡' },
    { label:'Attendance',  path:'/employee/attendance',  icon:'◉' },
    { label:'My Leaves',   path:'/employee/leaves',      icon:'◧' },
    { label:'Activity',    path:'/employee/activity',    icon:'◈' },
    { label:'My Report',   path:'/employee/report',      icon:'▤' },
    { label:'Privacy',     path:'/employee/transparency', icon:'🔒' },
    { label:'Profile',     path:'/employee/profile',     icon:'⊙' },
  ],
  hr: [
    { label:'HR Dashboard',path:'/hr',           icon:'⬡' },
    { label:'Leaves',      path:'/hr/leaves',    icon:'◧' },
    { label:'Employees',   path:'/hr/employees', icon:'◈' },
    { label:'Departments', path:'/hr/departments', icon:'▦' },
    { label:'Reports',     path:'/hr/reports',   icon:'▤'  },
    { label:'Analytics',   path:'/hr/analytics', icon:'◭'  },
    { label:'Audit Log',   path:'/hr/audit',    icon:'⛨'  },
    { label:'Consent',     path:'/hr/consent',  icon:'✍' },
    { label:'Profile',     path:'/hr/profile',   icon:'⊙' },
  ],
};

const COLORS = ['#63dcbc','#3ba8ff','#a78bfa','#f59e0b','#22c55e','#ef4444'];
const getInitials = n => (n||'').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();

export default function Sidebar({ collapsed, setCollapsed }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const navItems = NAV[user?.role] || NAV.employee;
  const colorPair = COLORS[(user?.full_name?.charCodeAt(0)||0) % COLORS.length];
  const W = collapsed ? 72 : 220;

  // Check if a nav item is active
  const isItemActive = (item) => {
    if (item.path === '/admin' || item.path === '/employee' || item.path === '/hr') {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <aside style={{
      width:W, minWidth:W,
      background:'#0a1018',
      borderRight:'1px solid rgba(56,189,248,0.08)',
      display:'flex', flexDirection:'column',
      padding: collapsed ? '20px 10px' : '22px 12px',
      transition:'width 0.25s ease, min-width 0.25s ease, padding 0.25s ease',
      overflow:'hidden', position:'relative', zIndex:10, flexShrink:0,
    }}>
      {/* Logo */}
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:28, justifyContent:collapsed?'center':'flex-start', paddingLeft:collapsed?0:4 }}>
        <img src="/logo-mark.png" alt="Prezence" style={{ width:34, height:34, flexShrink:0, objectFit:'contain', filter:'drop-shadow(0 0 12px rgba(0,219,231,0.35))' }} />
        {!collapsed && (
          <div>
            <div style={{ fontFamily:"'Playfair Display',serif",fontSize:15,fontWeight:800,background:'linear-gradient(135deg,#63dcbc,#3ba8ff)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent' }}>Prezence</div>
            <div style={{ fontSize:8,color:'#3ba8ff',letterSpacing:'0.2em',fontFamily:"'JetBrains Mono'" }}>BY PRELEGANT</div>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav style={{ flex:1, display:'flex', flexDirection:'column', gap:2 }}>
        {navItems.map(item => {
          const active = isItemActive(item);
          return (
            <NavLink key={item.path} to={item.path} title={collapsed ? item.label : ''} style={{ textDecoration:'none' }}>
              <div style={{
                display:'flex', alignItems:'center',
                gap:collapsed?0:10,
                justifyContent:collapsed?'center':'flex-start',
                padding:collapsed?'10px 0':'9px 11px',
                borderRadius:9,
                background: active ? 'rgba(99,220,188,0.1)' : 'transparent',
                border:`1px solid ${active?'rgba(99,220,188,0.25)':'transparent'}`,
                color: active ? '#63dcbc' : '#64748b',
                transition:'all 0.18s',
                cursor:'pointer',
              }}
                onMouseEnter={e => { if(!active){ e.currentTarget.style.background='rgba(255,255,255,0.04)'; e.currentTarget.style.color='#94a3b8'; }}}
                onMouseLeave={e => { if(!active){ e.currentTarget.style.background='transparent'; e.currentTarget.style.color='#64748b'; }}}
              >
                <span style={{ fontSize:15, lineHeight:1, flexShrink:0 }}>{item.icon}</span>
                {!collapsed && <span style={{ fontSize:13, fontWeight:600, fontFamily:"'DM Sans',sans-serif" }}>{item.label}</span>}
                {!collapsed && active && <div style={{ marginLeft:'auto', width:5,height:5,borderRadius:'50%',background:'#63dcbc',animation:'pulse-dot 2s infinite' }} />}
              </div>
            </NavLink>
          );
        })}
      </nav>

      {/* Clock */}
      {!collapsed && (
        <div style={{ borderTop:'1px solid rgba(56,189,248,0.08)', paddingTop:12, marginBottom:12, textAlign:'center' }}>
          <div style={{ fontFamily:"'JetBrains Mono'",fontSize:14,color:'#63dcbc',fontWeight:500 }}>
            {time.toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit',second:'2-digit'})}
          </div>
          <div style={{ fontSize:9,color:'#334155',marginTop:2,letterSpacing:'0.08em' }}>
            {time.toLocaleDateString('en-IN',{weekday:'short',day:'2-digit',month:'short'}).toUpperCase()}
          </div>
        </div>
      )}

      {/* User + logout */}
      <div style={{ borderTop:'1px solid rgba(56,189,248,0.08)', paddingTop:12, display:'flex', alignItems:'center', gap:collapsed?0:9, justifyContent:collapsed?'center':'flex-start' }}>
        <div style={{ width:32,height:32,borderRadius:8,flexShrink:0,background:`linear-gradient(135deg,${colorPair},#3ba8ff)`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800,color:'#05090f',cursor:'pointer' }}>
          {getInitials(user?.full_name)}
        </div>
        {!collapsed && (
          <>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:11,fontWeight:700,color:'#e2e8f0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis' }}>{user?.full_name}</div>
              <div style={{ fontSize:9,color:'#475569',textTransform:'capitalize' }}>{user?.role}</div>
            </div>
            <button onClick={logout} title="Logout" style={{ background:'none',border:'none',cursor:'pointer',color:'#334155',fontSize:14,padding:4,borderRadius:6,transition:'color 0.15s' }}
              onMouseEnter={e=>e.target.style.color='#ef4444'} onMouseLeave={e=>e.target.style.color='#334155'}>⏻</button>
          </>
        )}
      </div>

      {/* Collapse toggle */}
      <button onClick={() => setCollapsed(c=>!c)} style={{ position:'absolute',top:'50%',right:-11,transform:'translateY(-50%)',width:20,height:20,borderRadius:'50%',background:'#0d1520',border:'1px solid rgba(56,189,248,0.2)',color:'#475569',cursor:'pointer',fontSize:10,display:'flex',alignItems:'center',justifyContent:'center',zIndex:20,transition:'all 0.2s' }}
        onMouseEnter={e=>{e.currentTarget.style.color='#63dcbc';e.currentTarget.style.borderColor='rgba(99,220,188,0.5)';}}
        onMouseLeave={e=>{e.currentTarget.style.color='#475569';e.currentTarget.style.borderColor='rgba(56,189,248,0.2)';}}
      >{collapsed?'›':'‹'}</button>
    </aside>
  );
}
